import { accountSchema, type Account, type Status } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import accounts to the global cache from a list of accounts.
 *
 * @param accounts - array of Accounts
 */
function importAccounts(accounts: Account[]) {
  const parsedResult = filteredArray(accountSchema).safeParse(accounts);
  if (parsedResult.success) {
    importEntities(QueryKeys.accounts.global, parsedResult.data);
  }
}

/**
 * Import accounts to the global cache from a list of statuses.
 *
 * In each account, there are three possible account to import:
 *  - account itself
 *  - "quote" status's account
 *  - "reblog" status's account
 *
 * @param statuses - array of Statuses
 */
function importAccountsFromStatuses(statuses: Status[]) {
  const accountsToImport = statuses
    .flatMap((status) => [
      status.account,
      status.reblog?.account,
      status.quote?.account,
    ])
    .filter(Boolean);

  const parsedResult = filteredArray(accountSchema).safeParse(accountsToImport);
  if (parsedResult.success) {
    importEntities(QueryKeys.accounts.global, parsedResult.data);
  }
}

export { importAccounts, importAccountsFromStatuses };
